angular.module('jv.candidate.details.intelligent.messaging.controller',[])
    .controller('jvIntelligentMessagingController', ['$scope',
    function($scope){
        // Need to add the URL in backend once URl is finalised
        // added the watch to check the canvasRecruiterMiddleware object
        $scope.$watch(function () {
            return window.canvasRecruiterMiddleware;
        }, function(){
            if(window.canvasRecruiterMiddleware && window.canvasRecruiterMiddleware.loadHistoryView) {
                setTimeout(function(){
                    $scope.flags.loading = false;
                    window.canvasRecruiterMiddleware.loadHistoryView(document.getElementById('history'), {'atsRefKey': 'candidate|'+window.__applicationDetails.details.application.candidateEId});
                });
            }
        });
    }]
);